// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'roller-solid';

export const Component = () => (
  <path d='M23.567 1.005c.623.623.958 1.437.958 2.443.047.91-.288 1.724-.958 2.442-.719.719-1.533 1.005-2.442.958H8.816v4.932h4.933v4.886h.958v7.854h-2.921v-7.854h.958v-3.928H7.858v-5.89H3.404c-.91.047-1.724-.24-2.442-.958-.67-.72-1.005-1.533-.958-2.442 0-.958.336-1.772 1.006-2.443C1.68.335 2.494 0 3.404 0h17.72c.959 0 1.773.335 2.443 1.005Z' />
);

export const viewBox = '0 0 25 25';
